import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
    type IsoAndUnixTimestamp,
} from "@@/shared/date-time/iso-and-unix";
import { timeZodSchema, type Time } from "@@/shared/date-time/time";
import { idZodSchema } from "@@/shared/id";
import { ownerIdZodSchema, type OwnerId } from "@@/shared/owner-id";
import type {
    Translatable} from "@@/shared/translations/translation";
import {
    translatableZodSchema,
} from "@@/shared/translations/translation";
import { generateId } from "@@/utilities/generate-id";
import type { Except } from "type-fest";
import { z } from "zod";
import type { FeeId} from "../fee-id";
import { feeIdZodSchema } from "../fee-id";
import { feeSourceZodSchema } from "../fee-sources/fee-source";
import type { FeeTarget} from "../fee-target";
import { feeTargetZodSchema } from "../fee-target";
import type {
    CreateGeneralFee,
    CreateValueFee} from "./fee-create-command";
import {
    feeCreateZodSchema,
} from "./fee-create-command";

type FeeEditCommand = {
    readonly _id: string;
    readonly _type: "FEE_EDIT_COMMAND";
    readonly _createdAt: IsoAndUnixTimestamp;

    readonly feeId: FeeId;
    readonly ownerId: OwnerId;
    readonly title: Translatable;
    readonly description: Translatable;
    // readonly feeSource: FeeSource;
    readonly feeTarget: FeeTarget;
    readonly validTrough: Time;

    readonly type: CreateGeneralFee | CreateValueFee;
};

type FactoryParams = Except<FeeEditCommand, "_id" | "_type" | "_createdAt">;
const feeEditCommandFactory = (params: FactoryParams) => {
    const command: FeeEditCommand = {
        ...params,
        _id: generateId({ prefix: "fee_edit_command__" }),
        _type: "FEE_EDIT_COMMAND",
        _createdAt: nowIsoAndUnix(),
    };
    return command;
};

const feeEditCommandZodScheme: z.ZodSchema<FeeEditCommand> = z.object({
    _id: idZodSchema,
    _type: z.literal("FEE_EDIT_COMMAND"),
    _createdAt: isoAndUnixZodSchema,
    feeId: feeIdZodSchema,
    ownerId: ownerIdZodSchema,
    title: translatableZodSchema,
    description: translatableZodSchema,
    feeSource: feeSourceZodSchema,
    feeTarget: feeTargetZodSchema,
    validTrough: timeZodSchema,
    type: feeCreateZodSchema,
});

export { feeEditCommandFactory, feeEditCommandZodScheme };
export type { FeeEditCommand, FactoryParams as FeeEditCommandParams };
